import { AREAS, FAQS } from "@/content/site";
import { ARTICLES_BY_SLUG } from "@/content/approfondimenti";
import { CASES_BY_SLUG } from "@/content/cases";

export const SITE_NAME = "Dott. Alessandro Valle";
export const BASE_URL = "https://dottvalle.it";

// Meta ottimizzate per SEO locale (title < ~62 char, description < ~160 char).
const STATIC = {
  "/": {
    title: `Medicina estetica e laser a Genova · ${SITE_NAME}`,
    desc: "Studio medico a Genova del Dott. Alessandro Valle: trattamenti laser, Skin Quality, tricologia e tecnologie per il corpo. Ogni percorso parte da una valutazione medica.",
  },
  "/dott-alessandro-valle": {
    title: `Dott. Alessandro Valle · Medico estetico a Genova`,
    desc: "Il Dott. Alessandro Valle, Medico Chirurgo a Genova, e il suo approccio ai trattamenti laser, Skin Quality e tricologia. Valutazione medica individuale.",
  },
  "/studio-staff": {
    title: `Studio e staff a Genova · ${SITE_NAME}`,
    desc: "Lo studio e il team del Dott. Alessandro Valle a Genova: tecnologie laser, medicina estetica e percorsi personalizzati.",
  },
  "/contatti": {
    title: `Contatti e prenotazione a Genova · ${SITE_NAME}`,
    desc: "Prenota una valutazione medica presso lo studio del Dott. Alessandro Valle a Genova. Due sedi in centro città.",
  },
  "/tecnologie": {
    title: `Tecnologie laser e medicali a Genova · ${SITE_NAME}`,
    desc: "Le tecnologie laser e medicali dello studio del Dott. Alessandro Valle a Genova: CO₂, Er:YAG, Nd:YAG, luce pulsata, radiofrequenza e ultrasuoni focalizzati.",
  },
  "/approfondimenti": {
    title: `Approfondimenti · Laser e medicina estetica a Genova`,
    desc: "Approfondimenti dello studio del Dott. Alessandro Valle a Genova: laser CO₂ ed Er:YAG, cicatrici da acne, macchie e melasma, laser vascolare. Spiegati con chiarezza.",
  },
  "/risultati": {
    title: `Percorsi e Risultati | Dott. Alessandro Valle`,
    desc: "Percorsi e casi clinici documentati dei trattamenti di medicina estetica, laser, Skin Quality e tricologia del Dott. Alessandro Valle a Genova: problema, valutazione, protocollo e risultato.",
  },
  "/da-dove-iniziare": {
    title: `Da dove iniziare? · Percorso di orientamento | ${SITE_NAME}`,
    desc: "Non partire dalla tecnologia, parti dal problema. Un breve percorso orientativo per capire quale area (viso, corpo, capelli) e quali trattamenti valutare durante la visita. Non sostituisce la valutazione medica.",
  },
  "/privacy": {
    title: `Privacy Policy · ${SITE_NAME}`,
    desc: "Informativa sul trattamento dei dati personali del sito del Dott. Alessandro Valle.",
  },
  "/cookie-policy": {
    title: `Cookie Policy · ${SITE_NAME}`,
    desc: "Informativa sui cookie del sito del Dott. Alessandro Valle.",
  },
};

// Override curati per le pagine prioritarie (keyword + Genova).
const PAGE_META = {
  "/trattamenti-laser": {
    title: `Trattamenti laser a Genova · ${SITE_NAME}`,
    desc: "Trattamenti laser medicali a Genova: macchie, capillari, cicatrici, rimozione tatuaggi, resurfacing ed epilazione. Tecnologia scelta dopo valutazione medica.",
  },
  "/trattamenti-laser/rimozione-tatuaggi": {
    title: `Rimozione tatuaggi laser a Genova · ${SITE_NAME}`,
    desc: "Rimozione tatuaggi con laser a Genova: frammentazione selettiva del pigmento in più sedute. Valutazione preliminare presso lo studio del Dott. Alessandro Valle.",
  },
  "/trattamenti-laser/macchie-discromie": {
    title: `Trattamento macchie della pelle con laser · Genova`,
    desc: "Trattamento laser di macchie solari, lentigo e discromie a Genova, con tecnologia scelta in base a profondità e fototipo. Studio del Dott. Alessandro Valle.",
  },
  "/vascolare": {
    title: `Laser vascolare a Genova: capillari e couperose`,
    desc: "Trattamenti laser vascolari a Genova per couperose, capillari, teleangectasie, rossori e angiomi. Fotocoagulazione controllata dopo valutazione medica.",
  },
  "/vascolare/couperose": {
    title: `Trattamento couperose con laser a Genova`,
    desc: "Trattamento della couperose e dei capillari del viso con laser vascolare a Genova, con parametri scelti su colore e calibro del vaso. Studio Dott. Valle.",
  },
  "/cicatrici": {
    title: `Trattamento cicatrici con laser a Genova`,
    desc: "Trattamento laser delle cicatrici a Genova: da acne, chirurgiche, traumatiche e ipertrofiche, con protocolli combinati e miglioramento progressivo.",
  },
  "/cicatrici/cicatrici-da-acne": {
    title: `Cicatrici da acne: trattamento laser a Genova`,
    desc: "Trattamento delle cicatrici da acne a Genova con laser frazionati, radiofrequenza e tecniche rigenerative, calibrato sul tipo di cicatrice.",
  },
  "/lesioni-cutanee": {
    title: `Rimozione lesioni cutanee con laser a Genova`,
    desc: "Rimozione laser di lesioni cutanee superficiali e benigne a Genova (fibromi, cheratosi, verruche) dopo valutazione clinica. Le lesioni sospette non si trattano senza diagnosi.",
  },
};

const PAGE_LABELS = {
  contatti: "Contatti",
  "dott-alessandro-valle": "Dott. Alessandro Valle",
  "studio-staff": "Studio e staff",
  tecnologie: "Tecnologie",
  blog: "Approfondimenti",
  approfondimenti: "Approfondimenti",
  risultati: "Percorsi e Risultati",
  privacy: "Privacy Policy",
  "cookie-policy": "Cookie Policy",
};

function upsert(selector, create) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
}
function setNamed(name, content) {
  const el = upsert(`meta[name="${name}"]`, () => {
    const m = document.createElement("meta");
    m.setAttribute("name", name);
    return m;
  });
  el.setAttribute("content", content || "");
}
function setProp(prop, content) {
  const el = upsert(`meta[property="${prop}"]`, () => {
    const m = document.createElement("meta");
    m.setAttribute("property", prop);
    return m;
  });
  el.setAttribute("content", content || "");
}
function setCanonical(href) {
  const el = upsert('link[rel="canonical"]', () => {
    const l = document.createElement("link");
    l.setAttribute("rel", "canonical");
    return l;
  });
  el.setAttribute("href", href);
}
function ldScript(id, data) {
  let el = document.getElementById(id);
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function applySeo(pathname) {
  const parts = pathname.split("/").filter(Boolean);
  const post = parts[0] === "approfondimenti" && parts[1] ? ARTICLES_BY_SLUG[parts[1]] : null;
  const caseItem = parts[0] === "risultati" && parts[1] ? CASES_BY_SLUG[parts[1]] : null;

  let meta = PAGE_META[pathname] || STATIC[pathname];
  if (post) {
    meta = { title: post.metaTitle, desc: post.metaDescription };
  }
  if (caseItem) {
    meta = {
      title: `${caseItem.title} · Percorso clinico | ${SITE_NAME}`,
      desc: `${caseItem.protocol}. ${caseItem.summary && caseItem.summary["Problematica"] ? caseItem.summary["Problematica"] + ". " : ""}Percorso clinico documentato dello studio del Dott. Alessandro Valle a Genova.`.slice(0, 160),
    };
  }
  if (!meta) {
    const area = parts[0] && AREAS[parts[0]];
    if (area) {
      if (parts.length === 2) {
        const sub = (area.subs || []).find((s) => s.slug === parts[1]);
        meta = {
          title: `${sub ? sub.title : area.label} a Genova · ${SITE_NAME}`,
          desc: (sub && sub.body) || area.hero,
        };
      } else {
        meta = { title: `${area.label} a Genova · ${SITE_NAME}`, desc: (area.intro && area.intro[0]) || area.hero };
      }
    }
  }
  if (!meta) meta = { title: `${SITE_NAME} · Genova`, desc: "" };

  const absImage = (src) => (src && /^https?:\/\//.test(src) ? src : `${BASE_URL}${src || "/dott-valle.png"}`);
  const ogImage = post
    ? absImage(post.ogImage || post.cover)
    : caseItem
    ? absImage(caseItem.ogImage || `/casi/og-${parts[1]}.jpg`)
    : `${BASE_URL}/dott-valle.png`;

  const url = `${BASE_URL}${pathname}`;
  document.title = meta.title;
  setNamed("description", meta.desc);
  setProp("og:title", meta.title);
  setProp("og:description", meta.desc);
  setProp("og:type", post || caseItem ? "article" : "website");
  setProp("og:site_name", SITE_NAME);
  setProp("og:locale", "it_IT");
  setProp("og:image", ogImage);
  setProp("og:url", url);
  setNamed("twitter:card", "summary_large_image");
  setNamed("twitter:title", meta.title);
  setNamed("twitter:description", meta.desc);
  setNamed("twitter:image", ogImage);
  setCanonical(url);

  // Il dominio di anteprima Emergent e emergent.host restano noindex: indicizzabile solo il dominio definitivo dottvalle.it.
  const host = window.location.hostname;
  const isProd = /(^|\.)dottvalle\.it$/.test(host);
  setNamed("robots", isProd ? "index, follow" : "noindex, nofollow, noarchive");

  applyBreadcrumb(pathname);
  applyFaqLd(pathname);
  applyArticleLd(post, url);
  applyCaseLd(caseItem, url);
}

function applyBreadcrumb(pathname) {
  const parts = pathname.split("/").filter(Boolean);
  if (!parts.length) {
    ldScript("ld-breadcrumb", null);
    return;
  }
  const crumbs = [{ name: "Home", url: `${BASE_URL}/` }];
  const area = AREAS[parts[0]];
  if (area) {
    crumbs.push({ name: area.label, url: `${BASE_URL}/${parts[0]}` });
    if (parts.length === 2) {
      const sub = (area.subs || []).find((s) => s.slug === parts[1]);
      crumbs.push({ name: sub ? sub.title : parts[1], url: `${BASE_URL}/${parts[0]}/${parts[1]}` });
    }
  } else if (parts[0] === "approfondimenti") {
    crumbs.push({ name: "Approfondimenti", url: `${BASE_URL}/approfondimenti` });
    if (parts[1]) {
      const post = ARTICLES_BY_SLUG[parts[1]];
      crumbs.push({ name: post ? post.title : parts[1], url: `${BASE_URL}/approfondimenti/${parts[1]}` });
    }
  } else if (parts[0] === "risultati") {
    crumbs.push({ name: "Percorsi e Risultati", url: `${BASE_URL}/risultati` });
    if (parts[1]) {
      const c = CASES_BY_SLUG[parts[1]];
      crumbs.push({ name: c ? c.title : parts[1], url: `${BASE_URL}/risultati/${parts[1]}` });
    }
  } else {
    crumbs.push({ name: PAGE_LABELS[parts[0]] || parts[0], url: `${BASE_URL}/${parts[0]}` });
  }
  ldScript("ld-breadcrumb", {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((c, i) => ({ "@type": "ListItem", position: i + 1, name: c.name, item: c.url })),
  });
}

function applyFaqLd(pathname) {
  const parts = pathname.split("/").filter(Boolean);
  let faqs = FAQS[pathname.replace(/^\//, "")];
  if (parts[0] === "approfondimenti" && parts[1]) {
    const post = ARTICLES_BY_SLUG[parts[1]];
    faqs = post && post.faqs;
  }
  if (!faqs || !faqs.length) {
    ldScript("ld-faq", null);
    return;
  }
  ldScript("ld-faq", {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  });
}

function applyArticleLd(post, url) {
  if (!post) {
    ldScript("ld-article", null);
    return;
  }
  const img = /^https?:\/\//.test(post.cover) ? post.cover : `${BASE_URL}${post.cover}`;
  ldScript("ld-article", {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: post.title,
    description: post.metaDescription,
    image: img,
    inLanguage: "it-IT",
    datePublished: post.datePublished,
    dateModified: post.dateModified,
    mainEntityOfPage: { "@type": "WebPage", "@id": url },
    author: { "@id": `${BASE_URL}/#physician` },
    reviewedBy: { "@id": `${BASE_URL}/#physician` },
    publisher: { "@id": `${BASE_URL}/#physician` },
    isPartOf: { "@id": `${BASE_URL}/#website` },
  });
}

function applyCaseLd(caseItem, url) {
  if (!caseItem) {
    ldScript("ld-case", null);
    return;
  }
  const img = (caseItem.gallery && caseItem.gallery[0] && caseItem.gallery[0].src) || caseItem.after || caseItem.before;
  ldScript("ld-case", {
    "@context": "https://schema.org",
    "@type": "MedicalWebPage",
    name: caseItem.title,
    description: caseItem.protocol,
    inLanguage: "it-IT",
    image: img ? (/^https?:\/\//.test(img) ? img : `${BASE_URL}${img}`) : `${BASE_URL}/dott-valle.png`,
    mainEntityOfPage: { "@type": "WebPage", "@id": url },
    author: { "@id": `${BASE_URL}/#physician` },
    reviewedBy: { "@id": `${BASE_URL}/#physician` },
    publisher: { "@id": `${BASE_URL}/#physician` },
    isPartOf: { "@id": `${BASE_URL}/#website` },
    about: { "@type": "MedicalProcedure", name: caseItem.protocol },
  });
}

export function applyStructuredData(CONTACT) {
  const l = CONTACT.legal;
  const services = [
    "Rimozione tatuaggi laser",
    "Trattamento laser vascolare (couperose, capillari)",
    "Trattamento laser delle cicatrici",
    "Trattamento laser di macchie e discromie",
    "Rimozione laser di lesioni cutanee benigne",
    "Epilazione laser medicale",
    "Skin Quality e medicina rigenerativa",
    "Tricologia",
  ].map((name) => ({ "@type": "MedicalProcedure", name }));

  const knowsAbout = [
    "Medicina estetica",
    "Trattamenti laser medicali",
    "Rimozione tatuaggi laser",
    "Laser vascolare",
    "Trattamento cicatrici",
    "Macchie e discromie cutanee",
    "Lesioni cutanee benigne",
    "Skin quality",
    "Medicina rigenerativa",
  ];

  const address = (CONTACT.locations || []).map((loc) => ({
    "@type": "PostalAddress",
    streetAddress: loc.street,
    addressLocality: loc.locality,
    postalCode: loc.postalCode,
    addressRegion: loc.region,
    addressCountry: "IT",
  }));

  const physician = {
    "@type": "Physician",
    "@id": `${BASE_URL}/#physician`,
    name: l.fullName,
    honorificPrefix: "Dott.",
    jobTitle: l.role,
    medicalSpecialty: "Dermatology",
    url: BASE_URL,
    image: `${BASE_URL}/dott-valle.png`,
    logo: `${BASE_URL}/favicon.png`,
    telephone: CONTACT.phones[0] ? `+39${CONTACT.phones[0].href.replace(/^\+39/, "")}` : undefined,
    email: CONTACT.email,
    areaServed: { "@type": "City", name: "Genova" },
    knowsAbout,
    address,
    availableService: services,
    sameAs: Object.values(CONTACT.social || {}).filter(Boolean),
  };

  // Una sede clinica per ciascun indirizzo (SEO locale + Google Maps).
  const clinics = (CONTACT.locations || []).map((loc, i) => ({
    "@type": "MedicalClinic",
    "@id": `${BASE_URL}/#clinic-${i + 1}`,
    name: `${SITE_NAME} · ${loc.locality}`,
    url: BASE_URL,
    image: `${BASE_URL}/dott-valle.png`,
    logo: `${BASE_URL}/favicon.png`,
    telephone: loc.phone,
    email: CONTACT.email,
    medicalSpecialty: "Dermatology",
    address: {
      "@type": "PostalAddress",
      streetAddress: loc.street,
      addressLocality: loc.locality,
      postalCode: loc.postalCode,
      addressRegion: loc.region,
      addressCountry: "IT",
    },
    geo: { "@type": "GeoCoordinates", latitude: loc.lat, longitude: loc.lng },
    hasMap: loc.map,
    openingHoursSpecification: CONTACT.hours
      ? [{ "@type": "OpeningHoursSpecification", dayOfWeek: CONTACT.hours.days, opens: CONTACT.hours.opens, closes: CONTACT.hours.closes }]
      : undefined,
    areaServed: { "@type": "City", name: "Genova" },
    availableService: services,
    sameAs: Object.values(CONTACT.social || {}).filter(Boolean),
  }));

  const website = {
    "@type": "WebSite",
    "@id": `${BASE_URL}/#website`,
    url: BASE_URL,
    name: SITE_NAME,
    inLanguage: "it-IT",
    publisher: { "@id": `${BASE_URL}/#physician` },
  };

  ldScript("ld-physician", {
    "@context": "https://schema.org",
    "@graph": [physician, ...clinics, website],
  });
}
